import { isMenuDashboardAvailable } from '../utils/menu'

import { useInitData } from './useInitData'

export function useIsDashboardAvailable() {
  const { availableSections, sections } = useInitData()

  return isMenuDashboardAvailable({
    sectionsPermissions: sections,
    uiSections: availableSections,
  })
}
